'use client';

import { useMemo } from 'react';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import InputAdornment from '@mui/material/InputAdornment';
import { filledInputClasses } from '@mui/material/FilledInput';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';
import { allLangs, getLanguageData } from 'src/locales';
import { FlagIcon, flagIconClasses } from 'src/components/flag-icon';

// ----------------------------------------------------------------------

export function LanguageSelect({
  id,
  label,
  error,
  onChange,
  multiple,
  helperText,
  hiddenLabel,
  placeholder,
  getValue = 'name',
  ...other
}) {
  const options = useMemo(() => allLangs.map(language => getValue === 'name' ? language.name : language.adapterLocale), [getValue]);
  const renderOption = (props, option) => {
    const {
      code,
      name
    } = getLanguageData(option);
    return <li {...props} key={name}>
        <FlagIcon key={name} code={code} sx={{
        mr: 1,
        width: 22,
        height: 22,
        borderRadius: '50%'
      }} />
        {name} ({code})
      </li>;
  };
  const renderInput = params => {
    const {
      code: code_0,
      name: name_0
    } = getLanguageData(params.inputProps.value);
    const baseField = {
      ...params,
      label,
      helperText,
      hiddenLabel,
      placeholder,
      error: !!error,
      inputProps: {
        ...params.inputProps,
        autoComplete: 'new-password'
      }
    };
    if (multiple) return <TextField {...baseField} />;
    return <TextField {...baseField} slotProps={{
      input: {
        ...params.InputProps,
        startAdornment: code_0 && <InputAdornment position="start">
                <FlagIcon key={name_0} code={code_0} sx={{
            width: 22,
            height: 22,
            borderRadius: '50%'
          }} />
              </InputAdornment>
      }
    }} sx={{
      [`& .${outlinedInputClasses.root}`]: {
        [`& .${flagIconClasses.root}`]: {
          ml: 0.5,
          mr: -0.5
        }
      },
      [`& .${filledInputClasses.root}`]: {
        [`& .${flagIconClasses.root}`]: {
          ml: 0.5,
          mr: -0.5,
          mt: hiddenLabel ? 0 : -2
        }
      }
    }} />;
  };
  const renderValue = (selected, getTagProps) => {
    selected.map((option_0, index) => {
      const {
        code: code_1,
        name: name_1
      } = getLanguageData(option_0);
      return <Chip {...getTagProps({
        index
      })} key={name_1} label={name_1} size="small" variant="soft" icon={<FlagIcon key={name_1} code={code_1} sx={{
        width: 16,
        height: 16,
        borderRadius: '50%'
      }} />} />;
    });
  };
  return <Autocomplete options={options} multiple={multiple} autoHighlight={!multiple} renderInput={renderInput} renderOption={renderOption} id={`${id}-language-select`} disableCloseOnSelect={multiple} getOptionLabel={option_1 => option_1} renderValue={multiple ? renderValue : undefined} onChange={(event, newValue) => onChange?.(event, getLanguageData(newValue)?.adapterLocale ?? '')} {...other} />;
}